import { memo } from 'react';
import PageLayout from '@/components/PageLayout';
import SolutionsNav, { ISolutionsNavProp } from '@/components/SolutionsPage/solutionsNav';
import SolutionsMain, { ISolutionsMainProp } from '@/components/SolutionsPage/solutionsMain';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowUp from '@/components/UI/svg/Icons/EFArrowUp';
import EFComponentsIcon from '@/components/UI/svg/Naver/Icons/EFComponentsIcon';
import EFSoluComponentsIcon from '@/components/UI/svg/Naver/Icons/EFSoluComponentsIcon';
import EFCaculators from '@/components/UI/svg/Naver/Icons/EFCaculators';
import EFSoluCaculatorsIcon from '@/components/UI/svg/Naver/Icons/EFSoluCaculatorsIcon';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/solutions';

type ISolutions = {
    SEO: any;
    data: (isMobile: boolean, locale: string) => ISolutionsNavProp & { content: ISolutionsMainProp };
};
function Child({ SEO, data }: ISolutions) {
    const { useLang, isMobile, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solutions');

    const includeLocaleArr = ['us', 'uk', 'eu', 'fr', 'it', 'de', 'es', 'sa', 'za', 'au'];
    const includeLocale = includeLocaleArr.includes(locale);

    const { navList, content } = data(isMobile, locale);
    const len = navList.length;

    if (navList.length > 1 && !includeLocale) {
        navList[len - 1].tag = <EFArrowUp />;
    }
    if (navList.length > 2 && !includeLocale) {
        navList[len - 2].tag = <EFArrowUp />;
    }

    if (!isMobile) {
        if (navList.length > 1 && locale !== 'us') {
            navList[len - 2].icons = <EFSoluComponentsIcon />;
        }
        if (navList.length > 2 && locale !== 'us') {
            navList[len - 1].icons = <EFCaculators />;
        }
    } else {
        if (navList.length > 1 && locale !== 'us') {
            navList[len - 2].icons = <EFComponentsIcon />;
        }
        if (navList.length > 2 && locale !== 'us') {
            navList[len - 1].icons = <EFSoluCaculatorsIcon />;
        }
    }

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <PageLayout>
                <SolutionsNav query="solutions" navList={navList} />
                <SolutionsMain {...content} />
            </PageLayout>
        </>
    );
}

const MemoDom = memo(Child);

export default function Solutions({ SEO }: any) {
    const { useRouter, useEffect } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    useEffect(() => {
        if (!['us', 'ca', 'uk', 'fr', 'au', 'za', 'cn', 'jp', 'sa', 'it', 'es'].includes(locale) && typeof window !== 'undefined') {
            router.push(`${location.origin}/${locale}/404`);
        }
    }, []);
    let solutionsData = null;
    try {
        solutionsData = require(`@/data/solutions/${locale}`);
    } catch (err) {
        solutionsData = require('@/data/solutions/us');
    }
    return <MemoDom SEO={SEO} data={solutionsData} />;
}
